import RugCardDetailedMeta from './RugCardDetailedMeta'
export default RugCardDetailedMeta
